import {EventEmitter, Injectable} from "@angular/core";
import {UserService} from "../../../api/services/user.service";
import {map, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {NdmsUserManagementService} from "../../../../../shared/core/app/api/services/ndms-user-management.service";


@Injectable()
export class UserManagementService {
  public static currentData: any;
  public static currentNdmsData: any;
  locationChanged: EventEmitter<any> = new EventEmitter<any>();
  constructor(private userService:UserService,
              private ndmsUserManagementService: NdmsUserManagementService){

  }
  getCurrentCachedUser(){
    if(this.getUserSession()){
      return new Observable<any>((observer)=> {
        observer.next(this.getUserSession());
      });
    }

    return this.userService.GetCurrent().pipe(map((res)=>{
      this.setUserSession(res);
      UserManagementService.currentData = res.model;
      return res.model
    }));
  }
  getCurrentCachedNdmsUser(){
    if(this.getUserSession()){
      return new Observable<any>((observer)=> {
        observer.next(this.getUserSession());
      });
    }
    return this.ndmsUserManagementService.GetCurrentUser().pipe(map((res)=>{
      this.setUserSession(res);
      UserManagementService.currentNdmsData = res;
      return res
    }));
  }
  createUser(user){
    return this.userService.CreateUser(user).pipe(tap());
  }
  approveUser(user){
    return this.ndmsUserManagementService.UpdateUserAccess({accountStatus:{key:"401.2"},appItemName:"jpats",userKey:user.key}).pipe(tap());
  }
  denyUser(user){
    return this.ndmsUserManagementService.UpdateUserAccess({accountStatus:{key:"401.3"},appItemName:"jpats",userKey:user.key}).pipe(tap());
  }
  getCurrentUser(){
    return this.userService.GetCurrent().pipe(map((res)=>{
      this.setUserSession(res.model);
      UserManagementService.currentData = res.model || {};
      return res.model|| {};
    }));
  }
  getUserSession(){
    let authResult =window.sessionStorage.getItem("jpats_user");
    return JSON.parse(authResult || "{}")
  }
  clearUser(){
    window.sessionStorage.removeItem("jpats_user");
  }
  setUserSession(userData){
    window.sessionStorage.setItem("jpats_user",JSON.stringify(userData));
  }
  getCurrentNdmsUser(){

    return this.ndmsUserManagementService.GetCurrentUser().pipe(map((res)=>{
      UserManagementService.currentNdmsData = res || {};
      return res || {};
    }));
  }
  get(){
    return this.userService.Get().pipe(map((res)=>{
      return res;
    }));
  }
  getUserRoles(){
    return this.userService.GetAllRoles().pipe(map((res)=>{
      return res;
    }));
  }


  updateUserInfo(user){
    return this.userService.Save({userKey:user.key, userModel:user}).pipe(map((res)=>{
      return res.model;
    }));
  }
  getAllUsers(params){
    return this.userService.Query(params).pipe(map((res)=>{
      return res;
    }));
  }
  getAllPendingUsers(params){
    return this.ndmsUserManagementService.PendingUsersByAppName(Object.assign({},{appName:"jpats"},params)).pipe(tap());
  }
  updateLocation(locationInfo){
    return this.userService.SaveCurrent(locationInfo).pipe(map((res)=>{
      this.getCurrentUser().subscribe((data)=>{
        this.locationChanged.emit();
      });
    }));
  }
}
